import { useEffect, useState } from "react";
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import _ from 'lodash';
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { motion } from 'framer-motion';

/*
const voteAmountDiamond = [
    5,10,50,100,500,1000,2000
]
*/

export default function Review(props) {
    const { t, value, rank, selfWalletDiamond, isMobileView = false, 
        _confirmSubmitRank = () =>{}, setOpened =()=>{}, 
        selectedCompany, setSelectedCompany =()=>{}, 
        selectedAmount, setSelectedAmount =()=>{}, 
        submitTextChange, setSubmitTextChange =()=>{},
        voteAmountDiamond} = props;

        if(isMobileView == true){
            return(
                <>
                    <div className='vote-ranking-diamondRankingBoard-board-mobileItem'>
                        <div className='vote-ranking-diamondRankingBoard-board-mobileItem-inner'>
                            <div className='d-flex align-items-center flex-column'>
                                <div className='vote-ranking-diamondRankingBoard-board-mobileItem-rank'>
                                    <h3 className='custom_h3'>{rank}</h3>
                                </div>
                                <div className='vote-ranking-diamondRankingBoard-board-mobileItem-image'>
                                    <img src={`${process.env.NEXT_PUBLIC_FS_URL}${value.logo}`} alt="" className="img-fluid w-100" />
                                </div>
                                <div className='mt-2'>
                                    <h3 className='custom_h3 text-center'>{value.display_name}</h3>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='vote-ranking-diamondRankingBoard-board-mobileItem-diamondImage'>
                                        <img src={'/assets/images/diamond-user.svg'} alt="" className="img-fluid w-100" />
                                    </div>
                                    <h3 className='custom_h3 custom_colorPrimary'>{value.total_diamond}</h3>
                                </div>
                            </div>
                            
                            {/* REMOVE COMMENT TO ENABLE VOTE ON MOBILE VIEW */}
                            <div onClick={()=>{setOpened(true), setSelectedCompany(value.company_id), setSelectedAmount(-1)}} className='vote-ranking-diamondRankingBoard-board-mobileItem-bottom mt-2'>
                                <h3 className='custom_h3 custom_colorWhite'>{t("Vote_now")}</h3>
                            </div>

                            {/* ADD COMMENT TO DISABLE VOTE ON DESKTOP VIEW */}
                            { /* <div className='vote-ranking-diamondRankingBoard-board-mobileItem-bottom mt-2' style={{ opacity: .5, cursor: 'default', userSelect: 'none' }} data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Coming Soon">
                                <h3 className='custom_h3 custom_colorWhite'>{t("Vote_now")}</h3>
                            </div> */ }

                        </div>
                    </div>
                </>
            )
        }

        return (
            <>
                <div className='vote-ranking-diamondRankingBoard-board-item'>
                    <div className='vote-ranking-diamondRankingBoard-board-item-column'>
                        <h2 className='custom_h2'>{rank}</h2>
                    </div>
                    <div className='vote-ranking-diamondRankingBoard-board-item-column'>
                        { /* <a className='text-decoration-none' href={`/review/company/${value.custom_url}`} style={{ color: '#bb9b6a' }} title='Go to review page'>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-company-icon mx-auto'>
                                <img src={ value.logo ? `${process.env.NEXT_PUBLIC_FS_URL}${value.logo}` : '/assets/images/article-image-demo.png' } alt="" className="img-fluid w-100" />
                            </div>
                            <h4 className='custom_h4 text-center'>
                                {value.display_name}
                            </h4>
                        </a> */ }
                        <div className='vote-ranking-diamondRankingBoard-board-item-column-company-icon mx-auto'>
                            <img src={ value.logo ? `${process.env.NEXT_PUBLIC_FS_URL}${value.logo}` : '/assets/images/article-image-demo.png' } alt="" className="img-fluid w-100" />
                        </div>
                        <h4 className='custom_h4 text-center'>
                            {value.display_name}
                        </h4>
                    </div>
                    <div className='vote-ranking-diamondRankingBoard-board-item-column'>
                        <div className='custom_icon_size me-2'>
                            <img src="/assets/images/diamond-user.svg" alt="" className="img-fluid w-100" />
                        </div>
                        <h2 className='custom_h2 custom_colorPrimary'>{value.total_diamond}</h2>
                    </div>

                    {/* REMOVE COMMENT TO ENABLE VOTE ON DESKTOP VIEW */}
                    <div onClick={()=>{selectedCompany != value.company_id ? setSelectedCompany(value.company_id) : setSelectedCompany(0); setSelectedAmount(-1)}} className='vote-ranking-diamondRankingBoard-board-item-column'>
                        <h3 className='custom_h3'>{t("Vote_now")}</h3>
                        {selectedCompany == value.company_id ?
                            <AiFillCaretDown className='vote-ranking-diamondRankingBoard-board-item-column-dropdownIcon' size={40}/>
                        :
                            <AiFillCaretUp className='vote-ranking-diamondRankingBoard-board-item-column-dropdownIcon' size={40} />
                        }
                    </div>

                    {/* ADD COMMENT TO DISABLE VOTE ON DESKTOP VIEW */}
                    { /* <div className='vote-ranking-diamondRankingBoard-board-item-column' style={{ opacity: .5, cursor: 'default', userSelect: 'none' }} data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Coming Soon" title='Coming Soon'>
                        <h3 className='custom_h3'>{t("Vote_now")}</h3>
                        <AiFillCaretDown className='vote-ranking-diamondRankingBoard-board-item-column-dropdownIcon' size={40}/>
                    </div> */ }

                </div>
                {selectedCompany == value.company_id &&
                    <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box'>
                        <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-row'>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                                <h4 className='custom_h4'>{t("How_to_vote")}</h4>
                            </div>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column ps-4'>
                                <h4 className='custom_h4'>{t('Select_diamond')}</h4>
                            </div>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                                {selectedAmount >= 0 &&
                                    <motion.p 
                                        className='custom_p2'
                                        initial={{opacity: 0, y: '-50px'}}
                                        animate={{opacity: 1, y: 0}}
                                    >
                                        You've {submitTextChange == true ? 'voted' : 'selected'} <strong>{selectedAmount}</strong> diamonds!
                                    </motion.p>
                                }
                            </div>
                        </div>
                        <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-row2'>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                                <div className='d-flex'>
                                    <p className='custom_p2'><strong>Step 1.</strong></p>
                                    <p className='custom_p2'><strong>Select</strong> your preferred diamond.</p>
                                </div>
                                <div className='d-flex'>
                                    <p className='custom_p2'><strong>Step 2.</strong></p>
                                    <p className='custom_p2'>Click <strong>confirm</strong> to vote.</p>
                                </div>
                                <div className='d-flex'>
                                    <p className='custom_p2'><strong>Step 3.</strong></p>
                                    <p className='custom_p2'>You’ve succesfully voted for your favorite casino!</p>
                                </div>
                            </div>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column ps-4'>
                                <div className='d-flex flex-wrap'>
                                    {
                                        _.reduce(voteAmountDiamond, (result, value, key) => {
                                            result.push(
                                                <div 
                                                className={value === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                                                    key={key}
                                                    onClick={()=>{setSelectedAmount(value), setSubmitTextChange(false)}}
                                                >
                                                    <p className='custom_p2'>
                                                        <strong>{value}</strong>
                                                    </p>
                                                </div>
                                            )
                                            return result;
                                        }, [])
                                    }
                                    <div 
                                        className={selfWalletDiamond === selectedAmount ? 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button-active' : 'vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-vote-button'} 
                                        onClick={()=>{setSelectedAmount(selfWalletDiamond), setSubmitTextChange(false)}}
                                    >
                                        <p className='custom_p2'>
                                            <strong>{t('ALL')}</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-column'>
                                <div onClick={()=>{_confirmSubmitRank({companyId: value.company_id, diamondAmount: selectedAmount})}} className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-confirm-button'>
                                    <h3 className='custom_h3 custom_colorWhite'>{t('Confirm')}</h3>
                                </div>
                                {selectedAmount >= 0 &&
                                    <motion.div
                                        initial={{opacity: 0, y: '-50px'}}
                                        animate={{opacity: 1, y: 0}}
                                    >
                                        <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet'>
                                            <p className='custom_p2'>
                                                <strong>{selfWalletDiamond}</strong>
                                            </p>
                                            <p className='custom_p3 custom_colorRed'>
                                                <strong>{selectedAmount >= 0 && '-' + selectedAmount}</strong>
                                            </p>
                                            <div className='vote-ranking-diamondRankingBoard-board-item-column-dropdown-box-remainWallet-image'>
                                                <img src="/assets/images/diamond-icon.png" alt="" className="img-fluid w-100" />
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </>
        )
}